import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
interface Props {
  value: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TuiSwitch',
  props: {
    value: { type: Boolean }
  },
  emits: ['input'],
  setup(__props: any, { emit }) {

const props = __props as {
  value: boolean;
};





function toggleSwitch() {
  emit('input', !props.value);
}

return { __sfc: true,props, emit, toggleSwitch }
}

})